<template>
  <Modal :mayCancel="true" v-on:cancel="onDone">
    <p>You’ve succesfully added this whiteboard to your account.</p>
    <div class="ButtonRow-FlexRight">
      <button class="WBMBigButton m-primary" v-on:click="onDone">OK</button>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import { ModalMutations } from "@/store/modules/modal";

@Component({ components: { Modal } })
export default class ClaimedModal extends Vue {
  onDone() {
    ModalMutations.closeModals(this.$store.commit);
  }

  mounted() {
    history.replaceState(
      null,
      document.title,
      `${location.origin}${location.pathname}`
    );
  }
}
</script>

<style scoped lang="scss"></style>
